import { render, staticRenderFns } from "./InsightsFilters.vue?vue&type=template&id=1490cbed&scoped=true"
import script from "./InsightsFilters.vue?vue&type=script&lang=js"
export * from "./InsightsFilters.vue?vue&type=script&lang=js"
import style0 from "./InsightsFilters.vue?vue&type=style&index=0&id=1490cbed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490cbed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VList,VNavigationDrawer})
